import { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import Logo from "@/components/Logo";

const links = [
  { id: "solutions", label: "Industries" },
  { id: "showcase", label: "Reference" },
  { id: "case-studies", label: "Case Studies" },
  { id: "support", label: "Support" },
  { id: "about", label: "About" },
  { id: "contact", label: "Contact" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
    setOpen(false);
  };

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white/95 backdrop-blur-md border-b border-[#E2E8F0] shadow-sm" : "bg-white border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-[84px] flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center"
          aria-label="Smart Digi home"
        >
          <Logo size="lg" variant="dark" />
        </button>

        <nav className="hidden lg:flex items-center gap-1">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className="px-4 py-2 text-[15px] font-medium text-[#1E293B] hover:text-[#00439C] transition relative"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href="tel:+919818482197"
            className="hidden xl:inline-flex items-center gap-2 text-sm text-[#475569] hover:text-[#0F172A]"
          >
            <Phone size={15} /> +91 98184 82197
          </a>
          <button
            data-testid="nav-cta-quote"
            onClick={() => go("contact")}
            className="text-sm font-semibold px-5 py-2.5 bg-[#00439C] text-white hover:bg-[#003278] rounded-md transition-colors shadow-sm"
          >
            Request a Quote
          </button>
        </div>

        <button
          data-testid="nav-toggle-mobile"
          aria-label="Toggle menu"
          className="lg:hidden p-2 text-[#0F172A]"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden border-t border-[#E2E8F0] bg-white">
          <div className="px-6 py-5 flex flex-col gap-1">
            {links.map((l) => (
              <button
                key={l.id}
                data-testid={`mobile-nav-link-${l.id}`}
                onClick={() => go(l.id)}
                className="text-left py-3 text-[#1E293B] hover:text-[#00439C] font-medium border-b border-[#F1F3F7]"
              >
                {l.label}
              </button>
            ))}
            <button
              data-testid="mobile-cta-quote"
              onClick={() => go("contact")}
              className="mt-4 text-sm font-semibold px-5 py-3 bg-[#00439C] text-white rounded-md"
            >
              Request a Quote
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
